<nav class="navbar" [class.scrolled]="isScrolled">
  <div class="navbar__container">
    <a href="#inicio" class="navbar__logo" (click)="closeMenu()">
      <span class="navbar__logo-text">SP</span>
    </a>
    <button
      class="navbar__toggle"
      [class.active]="isMenuOpen"
      (click)="toggleMenu()"
      aria-label="Menú de navegación"
    >
      <span class="navbar__toggle-line"></span>
      <span class="navbar__toggle-line"></span>
      <span class="navbar__toggle-line"></span>
    </button>
    <ul class="navbar__menu" [class.open]="isMenuOpen">
      <li><a href="#inicio"  (click)="closeMenu()">Inicio</a></li>
      <li><a href="#skills"  (click)="closeMenu()">Skills</a></li>
      <li><a href="#sobre-mi" (click)="closeMenu()">Sobre mí</a></li>
      <li><a href="#proyectos" (click)="closeMenu()">Proyectos</a></li>
      <li><a href="#contacto" (click)="closeMenu()">Contacto</a></li>
    </ul>
  </div>
</nav>
